import { Carousel, FlexContainer, Layout, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import Star from 'Components/icons/Star';
import { ReviewsProps } from './types';

const FLEX_LITE_CONTEXT = 'flexLite';

const Reviews = ({ isFlexLite }: ReviewsProps): JSX.Element => {
  const { t } = useTranslation(locizeNS.PLANS);
  return (
    <Carousel
      mode="dark"
      items={[...Array(5).keys()].map(index => (
        <Layout.Wrap key={index} size="M" mode="light" hasBorder fullWidth>
          <FlexContainer direction="column" gap="dimension_08">
            <FlexContainer align="center" gap="dimension_16">
              <Text type="paragraphs" color="dark" size="S_XL_S">
                {t(`RatingsSlider.slide.${index + 1}.name`, {
                  context: isFlexLite && FLEX_LITE_CONTEXT,
                })}
              </Text>
              <FlexContainer>
                {[...Array(5).keys()].map(iconKey => (
                  <Star key={iconKey} />
                ))}
              </FlexContainer>
            </FlexContainer>
            <Text type="paragraphs" color="grey" size="S_S_S">
              {t(`RatingsSlider.slide.${index + 1}.description`, {
                context: isFlexLite && FLEX_LITE_CONTEXT,
              })}
            </Text>
          </FlexContainer>
        </Layout.Wrap>
      ))}
    />
  );
};

export default Reviews;
